import { useState, useMemo } from 'react';
import { FilterGroup, FilterOption } from '../components/GenericFilterSection';

const KNOWN_FILTERS = {
  'ราคา': 'price',
  'ช่วงราคา': 'price', 
  'ค่าเช่า/เดือน': 'price',
  'ห้องนอน': 'bedroom',
  'ห้องน้ำ': 'bathroom',
  'สถานะ': 'status',
  'ชั้น': 'floor',
  'วิว': 'view',
  'ทิศ': 'direction',
  'ประกาศโดย': 'publishedBy',
  'ลงประกาศเมื่อ': 'postedDate',
  'ระยะห่าง': 'distance'
} as const;

const FILTER_LAYOUTS = {
  'ระยะห่าง': 'single',  // ปกติจะมีไม่กี่ตัวเลือก
  'รูปแบบ': 'single',     // ปกติจะมีไม่กี่ตัวเลือก
  'ประกาศโดย': 'single',  // มี 4 ตัวเลือก
} as const;

interface ApiFilterState {
  knownFilters: string[];
  unknownFilters: FilterGroup[];
  genericFilterSelections: Record<number, string | null>; // group_id -> selected option id
}

export const useApiFilterManager = (filtersData: FilterGroup[]) => {
  const [genericFilterSelections, setGenericFilterSelections] = useState<Record<number, string | null>>({});

  const { knownFilters, unknownFilters } = useMemo(() => {
    const known: string[] = [];
    const unknown: FilterGroup[] = [];

    filtersData.forEach(group => {
      const groupNameTh = group.group_name_th || group.group_name;
      const knownFilterType = KNOWN_FILTERS[groupNameTh as keyof typeof KNOWN_FILTERS];

      if (knownFilterType) {
        if (!known.includes(knownFilterType)) {
          known.push(knownFilterType);
        }
      } else {
        unknown.push(group);
      }
    });

    return { knownFilters: known, unknownFilters: unknown };
  }, [filtersData]);

  const handleGenericFilterSelect = (groupId: number, value: string | null, option: FilterOption) => {
    setGenericFilterSelections(prev => ({
      ...prev,
      [groupId]: value
    }));


  };

  const getFilterLayout = (groupNameTh: string): 'single' | 'double' => {
    return FILTER_LAYOUTS[groupNameTh as keyof typeof FILTER_LAYOUTS] || 'double';
  };

  const getSelectionForGroup = (groupId: number): string | null => {
    return genericFilterSelections[groupId] || null;
  };

  const resetGenericSelections = () => {
    setGenericFilterSelections({});
  };

  const getSelectedQueryParams = (): Record<string, any> => {
    const allParams: Record<string, any> = {};

    unknownFilters.forEach(group => {
      const selectedOptionId = genericFilterSelections[group.group_id];
      if (selectedOptionId) {
        const selectedOption = group.options.find(opt => opt.id.toString() === selectedOptionId);
        if (selectedOption) {
          Object.assign(allParams, selectedOption.query_params);
        }
      }
    });

    return allParams;
  };

  return {
    knownFilters,
    unknownFilters,
    genericFilterSelections,
    
    handleGenericFilterSelect,
    resetGenericSelections,
    
    getFilterLayout,
    getSelectionForGroup,
    getSelectedQueryParams,
    
    hasUnknownFilters: unknownFilters.length > 0,
    unknownFiltersCount: unknownFilters.length
  };
}; 